export const downloadFile = async (content: Blob | MediaSource, fileName: string) => {
  const anchor = document.createElement('a');
  anchor.href = URL.createObjectURL(await content);
  anchor.target = '_blank';
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(anchor.href);
};
